import { z } from "zod";

export const schema = z.object({
    nome: z.string().min(1, "Nome é obrigatório").max(25, "Certifique-se de que este campo não tenha mais de 25 caracteres"),
    descricao: z.string().min(1, "Descrição é obrigatória").max(100, "Certifique-se de que este campo não tenha mais de 100 caracteres"),
    peso: z.number().min(0, "Peso deve ser maior ou igual a 0").max(10, "Peso deve ser menor ou igual a 10"),
    ativo: z.boolean(),
    cor_tag: z.string()
        .min(1, "Cor da tag é obrigatória")
        .max(7, "Certifique-se de que este campo não tenha mais de 7 caracteres")
        .regex(/^#[0-9A-Fa-f]{6}$/, "Informe um código de cor hexadecimal válido"),
    cor_fonte: z.string()
        .min(1, "Cor da fonte é obrigatória")
        .max(7, "Certifique-se de que este campo não tenha mais de 7 caracteres")
        .regex(/^#[0-9A-Fa-f]{6}$/, "Informe um código de cor hexadecimal válido"),
    sigla_senha: z.string().min(1, "Sigla da senha é obrigatória"),
    icone: z.instanceof(File, {
        message: "Arquivo de ícone é obrigatório",
    })
        .refine(file => {
            const allowedTypes: { [key: string]: boolean } = {
                "image/png": true,
            };
            return allowedTypes[file.type];
        }, { message: "Formato inválido. Apenas PNG é permitido." })
        .refine(file => file.size <= 1 * 1024 * 1024, {
            message: "O arquivo deve ter no máximo 1MB",
        })
        .refine(
            file =>
                new Promise<boolean>(resolve => {
                    const img = new Image();
                    img.onload = () => {
                        resolve(
                            img.width <= 240 &&
                            img.height <= 240
                        );
                    };
                    img.onerror = () => resolve(false);
                    img.src = URL.createObjectURL(file);
                }),
            {
                message: "A resolução deve ser no máximo 240x240 pixels",
            }
        )
        .or(z.string()),
});
